"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryCountrySelectOptions = exports.billingCountrySelectOptions = void 0;
var constants_1 = require("../constants");
// Billing country can be any country.
exports.billingCountrySelectOptions = constants_1.COUNTRIES.map(function (country, index) { return ({
    label: country,
    value: index,
}); });
// Delivery country can only be one of a sub-set of countries.
exports.deliveryCountrySelectOptions = constants_1.DELIVERY_COUNTRIES.map(function (country, index) { return ({
    label: country,
    value: index,
}); });
